import React from 'react';
import '../App.css';
import $ from 'jquery';
import config from '.././config.json';
import DeleteStudentForm from './DeleteStudentForm';
import EditStudentForm from './EditStudentForm';
import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';

import { Table, Input, Button, Icon, Badge, Modal, Popconfirm, notification, Select, Form, Col, Row} from 'antd';
const Option = Select.Option;
const FormItem = Form.Item;
const formItemLayout = {
    labelCol: {
        xs: { span: 0 },
        sm: { span: 2 },
    },
    wrapperCol: {
        xs: { span: 0 },
        sm: { span: 2 },
    },
};

class EditStudent extends React.Component {


    state = {
        studentEdit: false,
        studentDelete: false,
        classData: [],
        updateData: {},
        login: true,
        dropClass: [],
        lastNameArr: [],
        fullData: [],
        EmpInfo: [],
        sortedInfo: null,
    };

    dateofBirth = "2017-10-10";
    studentID = "";

    classSearch = 'All';
    lastNameSearch = 'None';

    componentDidMount() {
        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, //logout
            () => { this.refresh(); }); //login
    }

    refresh() {
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getall`
        })
            .done((data) => {
                console.log('got the data!');
                console.log(data);
                var seenNames = {};
                this.array = data;
                this.array = this.array.filter(function (currentObject) {
                    if (currentObject.LastName in seenNames) {
                        return false;
                    } else {
                        seenNames[currentObject.LastName] = true;
                        return true;
                    }
                });

                this.setState({
                    fullData: data,
                    lastNameArr: this.array
                });


            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/classes/getall`
        })
            .done((data) => {
                console.log('got the data!');
                console.log(data);
                this.setState({
                    dropClass: data
                })
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });

    }

    // These functions are for the search drop down
    onInputChange = (e) => {
        this.setState({ searchText: e.target.value });
    }
    /**
    * Opens a notification window
    */
    openNotificationWithIcon = (type, title, body) => {
        notification[type]({
            message: title,
            description: body,
        });
    };

    /**
     * Opens EditStudentFrom to edit a students info
     * @param {any} record
     */
    edit(record) {

        this.dateofBirth = record.DateofBirth;
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getemployer/` + record.Id
        })
            .done((data) => {
                this.setState({
                    EmpInfo: data,
                    updateData: record,
                });
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });

        this.showEdit();
    }

    /**
     * Opens DeleteStudentForm to delete a students record
     * @param {any} record
     */
    delete(record) {
        this.studentID = record.Id;
        this.dateofBirth = record.DateofBirth;
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getemployer/` + record.Id
        })
            .done((data) => {
                this.setState({
                    EmpInfo: data,
                    updateData: record,
                });
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });

        this.showDelete();
    }

    /**
    * Callback that fires when a students info is updated
    */
    handleOk = (e) => {
        this.refresh();
        this.filterStudent();
        this.setState({
            studentEdit: false,
            studentDelete: false,
        });
    }

    /**
    * Callback that fires when a user Cancels and update
    */
    handleCancel = (e) => {
        console.log(e);
        this.setState({
            studentEdit: false,
            studentDelete: false,
        });
    }

    /**
    * Opens the EditSutdentForm
    */
    showEdit = () => {
        this.setState({
            studentEdit: true,
        });
    }

    /**
    * Opens the DeleteStudentForm
    */
    showDelete = () => {
        this.setState({
            studentDelete: true,
        });
    }

    handleClassChange = (value) => {

        this.classSearch = value;

    }

    handleLastNameChange = (value) => {

        var res = value.split("|");
        var lastname = res[0];
        this.lastNameSearch = lastname;
    }
    resetStudent = () => {
        this.props.form.setFieldsValue({
            ['classSearch']: '',
            ['searchLastName']: '',
        });

        //this.classSearch = 'All';
        //this.lastNameSearch = 'None';

        //this.filterStudent();

        this.setState({
            classData: [],
        });

    }

    filterStudent = () => {
        let data1 = this.state.fullData;

        if (this.classSearch !== 'All') {
            $.ajax({
                type: 'GET',
                url: `${config.serverUrl}/api/students/getclassstudents/` + this.classSearch
            })
                .done((data) => {
                    console.log('got the data!');
                    console.log(data);
                    data1 = data; 

                    if (this.lastNameSearch != 'None') {
                        let lastname = this.lastNameSearch;
                        data1 = data1.filter(function (item) {
                            if (item.LastName == lastname) {
                                return true;
                            }
                        });

                    }

                    this.setState({
                        classData: data1,
                    });

                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    console.log('failed to get data');
                });
        }
        else {

            $.ajax({
                type: 'GET',
                url: `${config.serverUrl}/api/students/getall`
            })
                .done((data1) => {
                  
                    this.setState({
                        classData: data1,
                    });

                    if (this.lastNameSearch !== 'None') {
                        let lastname = this.lastNameSearch;
                        data1 = data1.filter(function (item) {
                            if (item.LastName == lastname) {
                                return true;
                            }
                        });
                    }
                    this.setState({
                        classData: data1,
                    });
                   
                })

            
                .fail((jqXHR, textStatus, errorThrown) => {
                    console.log('failed to get data');
                });        
        }       
    }


    handleChangeSort = (pagination, filters, sorter) => {
        this.setState({
            sortedInfo: sorter,
        });
    }

    compareByChar(a, b) { if (a > b) { return -1; } if (a < b) { return 1; } return 0; }

    /**
     * Render function
     */
    render() {
        const { getFieldDecorator } = this.props.form;
        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        const Columns = [
            {
                title: 'Name',
                dataIndex: 'FirstName',
                key: 'FirstName',
                sorter: (a, b) => this.compareByChar(a.FirstName, b.FirstName),
                sortOrder: sortedInfo.columnKey === 'FirstName' && sortedInfo.order
             
            },

            {
                title: 'Last Name',
                dataIndex: 'LastName',
                sorter: (a, b) => this.compareByChar(a.LastName, b.LastName),
                sortOrder: sortedInfo.columnKey === 'LastName' && sortedInfo.order
            },
            {
                title: 'Email',
                dataIndex: 'Email',
            },
            {
                title: 'Tech ID (TCP/ESCC Only)',
                dataIndex: 'TechID', 
                sorter: (a, b) => a.TechID - b.TechID,
                sortOrder: sortedInfo.columnKey === 'TechID' && sortedInfo.order,
            },
            {
                title: 'State',
                dataIndex: 'State',
            },
            {
                title: 'Address',
                dataIndex: 'StreetAddress',
            },

            {
                title: 'Action',
                dataIndex: 'edit',
                render: (text, record, index) => {
                    return (
                        <div className="editable-row-operations">
                            <span>
                                <a onClick={() => this.edit(record)}>Edit</a>
                                <a onClick={() => this.delete(record)}>Delete</a>
                            </span>
                        </div>
                    );
                }
            }
        ];

        // render stuff.. finally...
        return (
            <div>
                { this.state.login ?
                    <div>
                        {this.state.studentEdit && <EditStudentForm updateFields={this.state.updateData} updateEvent={this.handleOk} empData={this.state.EmpInfo} date={this.dateofBirth} />}
                        {this.state.studentDelete && <DeleteStudentForm updateFields={this.state.updateData} updateEvent={this.handleOk} empData={this.state.EmpInfo} date={this.dateofBirth} ID={this.studentID} />}

                        {!this.state.studentEdit && !this.state.studentDelete &&<div>
                            <h2>Manage Students</h2>
                            <hr /> 
                            <FormItem
                                {...formItemLayout}
                                label="Search Class"
                            >
                                {getFieldDecorator('searchClass')(
                                    <Select
                                        style={{ width: 900 }}
                                        showSearch
                                        placeholder="Class"
                                        optionFilterProp="children"
                                        onChange={this.handleClassChange}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        <Option key={'All'}>All</Option>
                                        {this.state.dropClass.map(a => <Option key={a.Id}>{a.Name}</Option>)}
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="Last Name"
                            >
                                {getFieldDecorator('searchLastName')(
                            <Select
                                style={{ width: 200 }}
                                showSearch
                                placeholder="Last Name"
                                optionFilterProp="children"
                                onChange={this.handleLastNameChange}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                <Option key={'None'}>None</Option>
                                {this.state.lastNameArr.map(a => <Option key={a.LastName + "|" + a.Id}>{a.LastName}</Option>)}
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem
                            >
                                <Row gutter={8}>
                                    <Col span={12}>
                                        <button className="btn btn-default" onClick={this.filterStudent} size="large">Search</button>&nbsp;
                                        <button className="btn btn-default" onClick={this.resetStudent} size="large">Reset</button>
                                    </Col>
                                </Row>
                            </FormItem>
                     
                            <Table rowKey="Id" bordered columns={Columns}
                            onChange={this.onChange}
                            dataSource={this.state.classData}
                            onChange={this.handleChangeSort}
                            pagination={{ pageSize: 30, current: this.state.current, onChange:(page, pageSize)=>{this.setState({current:page})}}}
                            />

                        </div>}
                    </div>
                    : <Redirect to="/login" replace />
                    }
            </div>
        );
    }
}

const WrappedEditStudent = Form.create()(EditStudent);
export default WrappedEditStudent;



// WEBPACK FOOTER //
// ./src/Admin/EditStudent.js